import request from '@/utils/http';
// 银行账户-查询详情
export const getFinanceMsg = (params) => {
    return request({
        url: `/api-srm-web/supplier/bankAccounts`,
        method: 'post',
        data: params
    });
};
// 工作台-银行账户-新增
export const saveWorkbenchBankAccount = (params) => {
    return request({
        url: `/api-srm-web/supplier/workbench/saveBankAccount`,
        method: 'post',
        data: params
    });
};
// 银行账户-MIP新增
export const saveBankAccount = (params) => {
    return request({
        url: `/api-srm-web/supplier/mipFlow/saveBankAccount`,
        method: 'post',
        data: params
    });
};
// 银行账户-启用
export const startBankAccount = (params) => {
    return request({
        url: `/api-srm-web/supplier/bankAccount/enable`,
        method: 'put',
        data: params
    });
};
// 银行账户-停用
export const stopBankAccount = (params) => {
    return request({
        url: `/api-srm-web/supplier/bankAccount/disable`,
        method: 'put',
        data: params
    });
};
// 银行账户-删除
export const deleteBankAccount = (params) => {
    return request({
        url: `/api-srm-web/supplier/bankAccount/batchDelete`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
// // 管理端-银行账户-变更
// export const changeBankAccount = (params) => {
//     return request({
//         url: `/api-srm-web/supplier/bankAccount/change`,
//         method: 'post',
//         data: params
//     });
// };
// 管理端-银行账户-MIP变更
export const changeBankAccount = (params) => {
    return request({
        url: `/api-srm-web/supplier/mipFlow/changeBankAccount`,
        method: 'post',
        data: params
    });
};
// 工作台-银行账户-变更
export const changeBySupplier = (params) => {
    return request({
        url: `/api-srm-web/supplier/workbench/changeBySupplier`,
        method: 'post',
        data: params
    });
};

// 银行账户刷新
export const refreshBankAccount = (id, params = {}) => {
    return request({
        url: `/api-srm-web/supplier/updateUbankNoAndBankAddress/${id}`,
        method: 'put',
        params: params
    });
};

// 设置主付款号
export const setMainPaymentNumber = (params) => {
    return request({
        url: `/api-srm-web/supplier/setMainPaymentNumber`,
        method: 'put',
        data: params
    });
};

// 设置待收款账号
export const setPaymentCollectionFlag = (params) => {
    return request({
        url: `/api-srm-web/supplier/setPaymentCollectionFlag`,
        method: 'put',
        data: params
    });
};

// 银行账户-获取审批详情
export const viewFinanceMipForm = (id) => {
    return request({
        url: `/api-srm-web/supplier/supplierFinanceInfo/viewFinanceMipForm/${id}`,
        method: 'get'
    });
};

// 注册美的付初始化数据
export const getRegisterPageInitData = (id) => {
    return request({
        url: `/api-srm-web/supplier/mideaPay/getRegisterPageInitData/${id}`,
        method: 'get'
    });
};

// 银行账户-提交审批
export const submitFlow = (params) => {
    return request({
        url: `/api-srm-web/supplier/financeInfo/submitFlow`,
        method: 'post',
        data: params
    });
};

// 银行账户-获取审批iflow信息
export const getChangeApplyAudit = (id) => {
    return request({
        url: `/api-srm-web/supplier/financeInfo/getChangeApplyAudit/${id}`,
        method: 'get'
    });
};

// 账号解冻申请
export const accountUnfreezingApply = (id) => {
    return request({
        url: `/api-srm-web/supplier/accountUnfreezingApply/${id}`,
        method: 'get'
    });
};

// 财务解冻复核
export const accountUnfreezingCheck = (params) => {
    return request({
        url: `/api-srm-web/supplier/accountUnfreezingCheck`,
        method: 'post',
        data: params
    });
};

// 银行账户-搜索地址
export const searchByAddress = (params) => {
    return request({
        url: `/api-srm-web/supplier/financeInfo/searchByAddress`,
        method: 'post',
        data: params
    });
};

// 注册美的付提交
export const mideaPayRegister = (params) => {
    return request({
        url: `/api-srm-web/supplier/mideaPay/register`,
        method: 'post',
        data: params
    });
};

// 下载模板
export const downloadRegisterGuide = (params) => {
    return request({
        url: `/api-srm-web/public/supplier/supplierInfo/downloadRegisterGuide`,
        method: 'post',
        data: params,
        responseType: 'arraybuffer'
    });
};

// 法人注册美的付提交
export const legalMideaPayRegister = (params) => {
    return request({
        url: `/api-srm-web/supplier/supplierFinanceInfo/mideaPayRegister`,
        method: 'post',
        data: params
    });
};
// 银行账户-校验账户唯一
export const checkBankAccountUnique = (params) => {
    return request({
        url: `/api-srm-web/supplier/bankAccounts/checkBankAccountUnique`,
        method: 'post',
        data: params
    });
};
// 设置默认运费收款账号
export const setDefaultAccountFlag = (params) => {
    return request({
        url: `/api-srm-web/supplier/setDefaultAccountFlag`,
        method: 'post',
        data: params
    });
};